import { createDataAttributes } from '@/app/utils/createDataAttributes';

export interface DataGAProps {
  click: boolean;
  eventName?: string;
  group?: string;
  url?: string;
  text?: string;
  value?: string;
}

export const createDataGA = ({
  click,
  eventName,
  group,
  url,
  text,
  value,
}: DataGAProps) => {
  return createDataAttributes({
    'ga-click': click,
    'ga-event-name': eventName,
    'ga-group': group,
    'ga-url': url,
    'ga-text': text,
    'ga-value': value,
  });
};
